export function quickSortAscending(arr, property) {
  if (arr.length <= 1) {
      return arr;
  }

  const pivot = arr[Math.floor(arr.length / 2)];
  const left = [];
  const right = [];

  if (property) {
      for (let i = 0; i < arr.length; i++) {
          if (i === Math.floor(arr.length / 2)) {
              continue;
          }
          if (arr[i][property] < pivot[property]) {
              left.push(arr[i]);
          } else {
              right.push(arr[i]);
          }
      }
  } else {
      for (let i = 0; i < arr.length; i++) {
          if (i === Math.floor(arr.length / 2)) {
              continue;
          }
          if (arr[i] < pivot) {
              left.push(arr[i]);
          } else {
              right.push(arr[i]);
          }
      }
  }

  return [...quickSortAscending(left, property), pivot, ...quickSortAscending(right, property)];
}

export function quickSortDescending(arr, property) {
  if (arr.length <= 1) {
    return arr;
  }

  const pivot = arr[Math.floor(arr.length / 2)];
  const left = [];
  const right = [];

  if (property) {
    for (let i = 0; i < arr.length; i++) {
      if (i === Math.floor(arr.length / 2)) {
        continue;
      }
      if (arr[i][property] >= pivot[property]) {
        left.push(arr[i]);
      } else {
        right.push(arr[i]);
      }
    }
  } else {
    for (let i = 0; i < arr.length; i++) {
      if (i === Math.floor(arr.length / 2)) {
        continue;
      }
      if (arr[i] >= pivot) {
        left.push(arr[i]);
      } else {
        right.push(arr[i]);
      }
    }
  }

  return [...quickSortDescending(left, property), pivot, ...quickSortDescending(right, property)];
}